import { useContext } from "react";
import { MessageContext } from "../Providers/MessageProvider";

function useMessage() {
  const { message, addMessage, removeMessage } = useContext(MessageContext);
  return { message, addMessage, removeMessage };
}

export default useMessage;
